package one.healthium.log_symptoms.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultLogSymptomsComponent(
    componentContext: ComponentContext,
    override val taskId: String?,
    private val onBackClicked: () -> Unit,
) : LogSymptomsComponent, ComponentContext by componentContext,
    ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}